import { useTranslation } from 'react-i18next'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { IContractItem } from 'types/contracts'

interface Props {
  isOpen: boolean
  onClose: () => void
  onPublish: () => void
  contract: IContractItem
}

export function PublishContractForm({
  isOpen,
  onClose,
  contract: { contractNumber },
  onPublish,
}: Props) {
  const { t } = useTranslation()

  return (
    <Dialog fullWidth open={isOpen} onClose={onClose}>
      <DialogTitle>{t('publish-contract')}</DialogTitle>
      <DialogContent>
        <Box>
          <Typography>
            {t('sure-to-publish-contract', { contractNumber })}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display="flex" gap={1}>
          <Button onClick={onClose} variant="outlined">
            {t('cancel')}
          </Button>
          <Button
            variant="contained"
            style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
            autoFocus
            onClick={onPublish}
          >
            {t('publish')}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}
